import { request, exportCsvData, importData, downloadTemplate } from "./api";
import { ContactInterface } from "../types";

const BASE_PATH = `/contacts`;

interface SendReqConfig {
  method?: "GET" | "POST" | "PUT" | "DELETE";
  id?: string;
  data?: any;
  params?: string;
}

export async function sendReq<T>({
  method = "GET",
  id,
  data,
  params = "",
}: SendReqConfig = {}) {
  return await request<T>({ method, id, data, params, basePath: BASE_PATH });
}

export interface PaginatedContactsResponse {
  data: ContactInterface[];
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
}

export async function getContacts(
  params?: string,
): Promise<PaginatedContactsResponse> {
  return await sendReq({ params });
}

export async function exportContacts(params?: string): Promise<void> {
  return await exportCsvData(BASE_PATH, params);
}

export async function importContacts(data: any[]): Promise<any> {
  return await importData(BASE_PATH, data);
}

export async function downloadContactsTemplate(): Promise<void> {
  return await downloadTemplate(BASE_PATH);
}

export async function getContact(id: string) {
  return (await sendReq<ContactInterface>({ id })).data;
}

export async function createContact(
  data: Partial<ContactInterface>,
): Promise<ContactInterface> {
  const contactData = { ...data, manual: true };
  return await sendReq({ method: "POST", data: contactData });
}

export async function updateContact(
  id: string,
  data: Partial<ContactInterface>,
): Promise<ContactInterface> {
  return await sendReq({ method: "PUT", id, data });
}

export async function deleteContact(id: string): Promise<void> {
  return await sendReq({ method: "DELETE", id });
}

export async function mergeContacts(
  masterId: string,
  otherId: string,
): Promise<any> {
  return await sendReq({
    method: "POST",
    params: "action=mergecontacts",
    data: { masterId, otherId },
  });
}

export async function addTimelineNote(
  contactId: string,
  data: { note: string; author?: string },
): Promise<any> {
  return await sendReq({
    method: "POST",
    id: contactId,
    params: "action=add_timeline_note",
    data,
  });
}

export async function updateTimelineNote(
  contactId: string,
  noteId: string,
  data: { note: string; author?: string },
): Promise<any> {
  return await sendReq({
    method: "PUT",
    id: contactId,
    params: `action=update_timeline_note&note_id=${noteId}`,
    data,
  });
}

export async function deleteTimelineNote(
  contactId: string,
  noteId: string,
): Promise<any> {
  return await sendReq({
    method: "DELETE",
    id: contactId,
    params: `action=delete_timeline_note&note_id=${noteId}`,
  });
}

export async function sendWhatsApp(
  number: string,
  message: string,
): Promise<any> {
  return await sendReq({
    method: "POST",
    params: `action=sendWhatsapp`,
    data: {
      number,
      message,
    },
  });
}
